import Icon from '../Icon';
import { IconSpecificProps } from '../Icon.types';

const IconCart = (props: IconSpecificProps) => (
  <Icon {...props} viewBox="0 0 24 24" fill="none">
    <path
      d="M3 3.5H4.18213C4.40479 3.5 4.51612 3.5 4.60571 3.54072C4.68466 3.5766 4.75157 3.6343 4.79846 3.70695C4.85166 3.78939 4.8674 3.89899 4.89889 4.11818L5.32725 7.1M5.32725 7.1L6.27926 14.0583C6.40007 14.9413 6.46048 15.3828 6.67276 15.7151C6.85981 16.008 7.12798 16.2408 7.44499 16.3856C7.80475 16.55 8.25282 16.55 9.14896 16.55H16.8942C17.7473 16.55 18.1738 16.55 18.5224 16.3974C18.8297 16.2628 19.0933 16.0459 19.2838 15.7708C19.4998 15.4589 19.5796 15.0422 19.7392 14.2089L20.9372 7.95472C20.9933 7.66143 21.0214 7.51478 20.9807 7.40015C20.945 7.29959 20.8745 7.21492 20.7819 7.16122C20.6763 7.1 20.5261 7.1 20.2259 7.1H5.32725ZM10.2403 20.6C10.2403 21.0971 9.83515 21.5 9.3353 21.5C8.83546 21.5 8.43026 21.0971 8.43026 20.6C8.43026 20.1029 8.83546 19.7 9.3353 19.7C9.83515 19.7 10.2403 20.1029 10.2403 20.6ZM17.4807 20.6C17.4807 21.0971 17.0755 21.5 16.5757 21.5C16.0758 21.5 15.6706 21.0971 15.6706 20.6C15.6706 20.1029 16.0758 19.7 16.5757 19.7C17.0755 19.7 17.4807 20.1029 17.4807 20.6Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export default IconCart;
